<template>
  <div>
    <ComponentHeader
      title="Entity Reconciliation"
      :subtitle="activeSubTabDescription"
    />

    <div class="pt-2">
      <div class="flex gap-1 border-b border-gray-200">
        <button
          v-for="t in subTabs"
          :key="t.key"
          class="px-4 py-2 text-xs border-b-2 -mb-px"
          :class="activeSubTab === t.key
            ? 'border-blue-600 text-blue-600 font-medium'
            : 'border-transparent text-gray-600 hover:text-gray-900'"
          @click="selectSubTab(t.key)"
        >{{ t.label }}</button>
      </div>
    </div>

    <ReconciliationAssignment v-if="activeSubTab === 'assignment'" />
    <ReconciliationUnsupported v-if="activeSubTab === 'unsupported'" />
  </div>
</template>

<script>
import ComponentHeader from '@/components/widgetcomponents/library/ComponentHeader.vue';
import ReconciliationAssignment from '@/components/ETL_Utility/Reconciliation/Reconciliation_Assignment.vue';
import ReconciliationUnsupported from '@/components/ETL_Utility/Reconciliation/Reconciliation_Unsupported.vue';
import { RECONCILIATION_SUBTABS, dataReconciliationLocation } from '../../../../router/data_routes';

export default {
  name: 'OverviewETLReconciliation',
  components: { ComponentHeader, ReconciliationAssignment, ReconciliationUnsupported },
  data() {
    return {
      // Last sub-tab shown; keeps the pane steady while another /data tab is open.
      lastSubTab: 'assignment',
      subTabs: [
        {
          key: 'assignment',
          label: 'Assignment Coverage',
          description: 'Provider combinations patients are assigned to, and whether the app holds that relationship',
        },
        {
          key: 'unsupported',
          label: 'Unsupported Links',
          description: 'Staff parented to a TIN with no assignment or claims evidence behind it',
        },
      ],
    };
  },
  computed: {
    // The open sub-tab lives in the path: /data/reconciliation/:subtab.
    routeSubTab() {
      const route = this.$route;
      if (route?.name === 'DataReconciliation' && RECONCILIATION_SUBTABS.includes(route.params.subtab)) {
        return route.params.subtab;
      }
      return null;
    },
    onBareTab() {
      return this.$route?.name === 'DataTab' && this.$route.params.tab === 'reconciliation';
    },
    activeSubTab() {
      return this.routeSubTab || this.lastSubTab;
    },
    activeSubTabDescription() {
      const t = this.subTabs.find((x) => x.key === this.activeSubTab);
      return t ? t.description : '';
    },
  },
  watch: {
    routeSubTab(v) {
      if (v) this.lastSubTab = v;
    },
    onBareTab: {
      immediate: true,
      handler(bare) {
        if (bare) this.$router.replace(dataReconciliationLocation(this.lastSubTab));
      },
    },
  },
  created() {
    if (this.routeSubTab) this.lastSubTab = this.routeSubTab;
  },
  methods: {
    selectSubTab(key) {
      if (key !== this.activeSubTab) this.$router.push(dataReconciliationLocation(key));
    },
  },
};
</script>
